import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { StoreProvider } from './contexts/StoreContext';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { CartDrawer } from './components/CartDrawer';
import { BookingDrawer } from './components/BookingDrawer';
import { MobileActionBar } from './components/MobileActionBar';
import { Home } from './pages/Home';
import { Treatments } from './pages/Treatments';
import { Shop } from './pages/Shop';
import { Journal } from './pages/Journal';
import { About } from './pages/About';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, [pathname]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="28te2fc3h77mk">
      <StoreProvider data-id="element-1" data-mp="28suv0pbgc1ms">
        <ScrollToTop data-id="element-2" data-mp="28s2y9b64bxux" />
        <div className="flex min-h-screen w-full flex-col bg-sand" data-id="element-3" data-mp="23vkuoemiy5k6">
          <Header data-id="element-4" data-mp="23t8g8bfz6dbv" />
          <main className="flex-1 pb-16 lg:pb-0" data-id="element-5" data-mp="3ijxokogyjwiu">
            <Routes data-id="element-6" data-mp="3ij61y35c994p">
              <Route path="/" element={<Home data-id="element-8" data-mp="3mlj98vzqhf3l" />} data-id="element-7" data-mp="3ihv22ef0kliv" />
              <Route path="/behandelingen" element={<Treatments data-id="element-10" data-mp="3mjq1tehaqquj" />} data-id="element-9" data-mp="3mkrefndynled" />
              <Route path="/webshop" element={<Shop data-id="element-12" data-mp="3rbznujfaj6rj" />} data-id="element-11" data-mp="3rc9d24sih9w6" />
              <Route path="/journal" element={<Journal data-id="element-14" data-mp="3relv0hy9rk98" />} data-id="element-13" data-mp="3rcsyvwla8ifh" />
              <Route path="/over-ons" element={<About data-id="element-16" data-mp="4n7g6m8exco" />} data-id="element-15" data-mp="6hovayao7c0" />
              <Route path="*" element={<Home data-id="element-18" data-mp="2zld0z6e9z99y" />} data-id="element-17" data-mp="82jf0klzq9v" />
            </Routes>
          </main>
          <Footer data-id="element-19" data-mp="2zmwguvw0rib7" />
          <MobileActionBar data-id="element-20" data-mp="2zng2onosiqui" />
          <CartDrawer data-id="element-21" data-mp="33m5ck6amdq9e" />
          <BookingDrawer data-id="element-22" data-mp="33nges1of2pye" />
        </div>
      </StoreProvider>
    </BrowserRouter>;
}